import tw, { css } from "twin.macro";

const GlobalStyles = css`
  :root {
    --border: #e4e4e7;
    --border-high: #e5e5e5;
    --text-high: #0d0d0d;
    --text-high-inverted: #f2f2f2;
    --text-mid: #666;
    --text-low: #b2b2b2;
    --surface-input-field: #f2f2f2;
    --surface-background: #ffffff;
    --muted-foreground: #71717a;
    --primary: #12a232;
    --button-secondary: #e5e5e5;
  }

  .dark {
    :root {
      --border-high: #333;
      --text-high: #f2f2f2;
      --text-high-inverted: #0d0d0d;
      --text-mid: #999;
      --text-low: #4d4d4d;
      --surface-input-field: #1a1a1a;
      --surface-background: #000000;
      --button-secondary: #1a1a1a;
    }
  }

  * {
    margin: 0;
    padding: 0px;
    box-sizing: border-box;
  }

  html {
    font-size: 10px;
  }

  *,
  body,
  button {
    margin: 0;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
    font-optical-sizing: auto;
    font-feature-settings: "liga" 1, "calt" 1;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1rem;
    ${tw`text-text-high`};

    ${tw`bg-white dark:bg-black`};
  }

  button {
    cursor: pointer;
    outline: none;
  }

  code {
    font-family: "Roboto Mono";
  }

  .apexcharts-tooltip {
    background-color: transparent;
    border: none;
  }

  *::-webkit-scrollbar {
    display: block;
    ${tw`bg-surface-inputField`};
    width: 0px;
  }

  *::-webkit-scrollbar-thumb {
    ${tw`rounded-[99px] bg-greyScale80 dark:bg-greyScale05`};
  }

  html.dark input::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
`;

export default GlobalStyles;
